var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBurgerMenuWhite = function SvgBurgerMenuWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 8.75H.25v2.5h27.5v-2.5ZM27.75 0H.25v2.5h27.5V0ZM27.75 17.5H.25V20h27.5v-2.5Z",
    fill: "#fff"
  })));
};
export default SvgBurgerMenuWhite;